import { W14_NS, attr, firstKid } from './ns';

export const CHECKED_ON = '1';
export const CHECKED_OFF = '0';

const DEFAULT_CHECKED = '☒';
const DEFAULT_UNCHECKED = '☐';

export interface CheckBoxGlyphs {
  readonly checked: string;
  readonly unchecked: string;
}

export function readGlyphs(checkbox: Element): CheckBoxGlyphs {
  return {
    checked: stateChar(checkbox, 'checkedState') ?? DEFAULT_CHECKED,
    unchecked: stateChar(checkbox, 'uncheckedState') ?? DEFAULT_UNCHECKED,
  };
}

export function isChecked(checkbox: Element): boolean {
  return attr(firstKid(checkbox, 'checked', W14_NS), 'val', W14_NS) === CHECKED_ON;
}

function stateChar(checkbox: Element, local: string): string | undefined {
  const hex = attr(firstKid(checkbox, local, W14_NS), 'val', W14_NS);
  if (!hex) {
    return undefined;
  }

  return String.fromCodePoint(parseInt(hex, 16));
}
